// @ts-ignore
import { debounce } from 'lodash';
export class SearchList {
    list: HTMLElement | null;
    input: HTMLElement | null;
    empty: HTMLElement | null;
    items: NodeListOf<HTMLElement>;
    entriesFound: boolean;

    constructor(list: HTMLElement) {
        this.list = list;
        this.input = this.list.querySelector('[data-search-list-input]');
        this.empty = this.list.querySelector('[data-search-list-empty]');
        this.items = this.list.querySelectorAll('[data-search-list-item]');
        this.entriesFound = false;

        this.empty?.classList.add('d-none');
        this.input?.addEventListener('keyup', debounce((e: Event) => this.searchItems((e.target as HTMLInputElement).value.toLowerCase().trim()), 200));
    }

    searchItems(query: string) {
        this.entriesFound = false;

        this.items.forEach((item: HTMLElement) => {
            if (item.textContent) {
                this.setItemVisibility(query, item);
            }
        });

        this.entriesFound ? this.empty?.classList.add('d-none') : this.empty?.classList.remove('d-none');
    }

    setItemVisibility(query: string, item: HTMLElement) {
        const value = item.textContent?.toLowerCase() || '';
        if (query === '' || value.includes(query)) {
            this.entriesFound = true;
            item.classList.remove('d-none');
        } else {
            item.classList.add('d-none');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-search-list]').forEach(list => {
        new SearchList(list);
    })
})
